module.exports = __webpack_public_path__ + "img/magic-mouse.3cf7a781.png";